import { Identifiable, Role } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedPlanzoneResource } from "./types";

function linkResource(httpClient: HttpClient) {
  return (
    resource: LinkedPlanzoneResource,
  ): Promise<LinkedPlanzoneResource> => {
    return (
      resource.role
        ? Promise.resolve(resource.role)
        : httpClient.sendHttpRequest<Identifiable<Role>>({
            endpoint: `/resources/${resource.uuid}/role`,
            method: HttpMethods.GET,
          })
    )
      .then((role) => ({
        ...resource,
        role,
        tags: resource.tags.map((tag) => {
          // @ts-ignore
          return typeof tag === "string" ? { name: tag } : tag;
        }),
      }))
      .catch(() => ({
        ...resource,
        tags: resource.tags.map((tag) => {
          // @ts-ignore
          return typeof tag === "string" ? { name: tag } : tag;
        }),
      }));
  };
}

export { linkResource };
